import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pr-pill',
  templateUrl: './pr-pill.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'inline-flex items-center whitespace-nowrap rounded-full border border-solid px-2.5 py-0.5 text-xs font-medium leading-[18px]',
  },
})
export class PrPillComponent {}
